import type { SxProps, Theme } from '@mui/material';

export const styles = {
    intro: { mb: 2 } as SxProps<Theme>,
    sectionTitle: { fontWeight: 'bold', mb: 1, mt: 2 } as SxProps<Theme>,
    item: {
        mb: 2,
        p: 2,
        borderRadius: '8px',
        border: '1px solid',
        borderColor: 'grey.100',
    } as SxProps<Theme>,
    grid: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: 1,
        mt: 1,
    } as SxProps<Theme>,
    label: { fontSize: '12px', color: 'grey.500' } as SxProps<Theme>,
    value: { fontSize: '14px' } as SxProps<Theme>,
    priceOld: {
        textDecoration: 'line-through',
        color: 'grey.500',
        mr: 1,
    } as SxProps<Theme>,
    priceNew: { color: 'blue.main', fontWeight: 'bold' } as SxProps<Theme>,
    warning: (theme: Theme): SxProps<Theme> => ({
        color: theme.palette.yellow[900],
        mt: 2,
    }),
};
